/*
  clikt. — the motion system.

  One place decides what moves, which mechanic it uses, and how long the gap
  is between siblings. Sections get DIFFERENT effects on purpose: the same
  fade applied everywhere is what makes a site feel templated.

  Each rule is [container, children, effect, gap between siblings in ms].

  The gap is half the character. Most groups run tight, 60 to 130ms, so a
  row lands almost together. A few run slow on purpose: the process steps
  take a full second each so the reader is walked through them, and the
  scattered list of custom builds arrives a line at a time.
*/
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var RULES = [
    /* --------------------------------------------------------- homepage */
    ['.clikt-trust__list', ':scope > li', 'rise', 90],
    ['.clikt-paths__grid', ':scope > li, :scope > a', 'zoom', 120],
    ['.clikt-prods__head', ':scope > *', 'mask', 90],
    ['.clikt-prods__grid', ':scope > li', 'rise', 80],
    ['.clikt-c3d__inner', ':scope > *', 'expand', 0],

    /* the full-bleed activation band: the words are the whole point */
    ['.clikt-cdisp__copy', ':scope > *', 'rise', 110],
    ['.clikt-cdisp__inner', ':scope > .clikt-cdisp__chip', 'slide-right', 0],

    /* story block: photographs wipe up, copy comes in from its own side */
    ['.clikt-story__images', ':scope > img', 'mask', 240],
    ['.clikt-story__copy', ':scope > *', 'slide-right', 100],

    /* social proof and editorial lift off the page */
    ['.clikt-revs__rail', ':scope > li', 'tilt', 110],
    ['.clikt-journal__grid, .clikt-posts', ':scope > *', 'tilt', 130],

    /* ---------------------------------------------------- content pages */

    /*
      The four steps. A full second each, so it reads as a sequence being
      explained rather than a row of boxes appearing at once. This is the
      one place where a long wait is the point.
    */
    ['.clikt-act__steps', ':scope li', 'step', 500],
    ['.how-it-works__list', ':scope > li', 'step', 500],

    ['.clikt-act__hero-copy', ':scope > *', 'rise', 110],
    ['.clikt-act__hero-images', ':scope > img', 'zoom', 200],
    ['.clikt-act__moments-images', ':scope > img', 'in-right', 260],
    ['.clikt-act__band--brown .clikt-act__band-inner', ':scope > *', 'mask', 130],

    ['.clikt-split__copy', ':scope > *', 'slide-left', 100],
    ['.clikt-split__img', ':scope img', 'zoom', 0],

    ['.clikt-landing__points', ':scope > li', 'rise', 140],
    ['.clikt-faq__list', ':scope > *', 'rise', 70],

    ['.clikt-prose__body', ':scope > ul > li', 'rise', 0],
    ['.clikt-prose__body', ':scope > h2', 'mask', 0],

    ['.clikt-footer__cols', ':scope > *', 'rise', 80],
  ];

  /*
    The moments copy is tagged child by child rather than as a block, and
    the scattered list is skipped entirely: it runs its own line-at-a-time
    reveal, and wrapping it in a group reveal would hide the whole list
    until the block came in and kill that effect.
  */
  var MOMENTS = ['.clikt-act__moments-copy > h2', '.clikt-act__moments-copy > .clikt-act__body', '.clikt-act__scatter-label', '.clikt-act__signoff', '.clikt-act__moments-copy > .clikt-act__ctas'];

  /* Headings set word by word. Kept to the statements that carry the site,
     so it stays an event rather than a habit. */
  var WORD_HEADINGS = ['.clikt-hero__heading', '.clikt-cdisp__heading', '.clikt-act__title'];

  var MAX_STEPS = 8; // cap the wait on very long groups

  function tag(el, fx, delay) {
    if (!el || el.hasAttribute('data-clikt-fx')) return;
    el.setAttribute('data-clikt-fx', fx);
    if (delay) el.style.setProperty('--clikt-delay', delay + 'ms');
  }

  /* Split a heading into one span per word, each with its own delay. */
  function splitWords(el) {
    if (el.dataset.cliktSplit) return;
    el.dataset.cliktSplit = '1';

    var nodes = [].slice.call(el.childNodes);
    var index = 0;

    nodes.forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(function (chunk) {
          if (!chunk.trim()) {
            frag.appendChild(document.createTextNode(chunk));
            return;
          }
          var span = document.createElement('span');
          span.className = 'clikt-word';
          span.textContent = chunk;
          span.style.setProperty('--clikt-word-delay', index * 90 + 'ms');
          index++;
          frag.appendChild(span);
        });
        el.replaceChild(frag, node);
      } else if (node.nodeType === 1) {
        /* An <em> keeps its own styling, so wrap the element rather than
           its text and the accent colour survives. */
        node.classList.add('clikt-word');
        node.style.setProperty('--clikt-word-delay', index * 90 + 'ms');
        index++;
      }
    });
  }

  function collect() {
    RULES.forEach(function (rule) {
      var containers = document.querySelectorAll(rule[0]);

      for (var c = 0; c < containers.length; c++) {
        var kids = rule[1] === ':scope' ? [containers[c]] : containers[c].querySelectorAll(rule[1]);

        for (var k = 0; k < kids.length; k++) {
          tag(kids[k], rule[2], Math.min(k, MAX_STEPS) * rule[3]);
        }
      }
    });

    MOMENTS.forEach(function (sel, i) {
      var found = document.querySelectorAll(sel);
      for (var n = 0; n < found.length; n++) tag(found[n], 'rise', i * 90);
    });

    WORD_HEADINGS.forEach(function (sel) {
      var found = document.querySelectorAll(sel);
      for (var i = 0; i < found.length; i++) {
        splitWords(found[i]);
        /* The hero heading is released by the load sequence, not by scroll. */
        if (!found[i].closest('.clikt-hero')) tag(found[i], 'words', 0);
      }
    });
  }

  function watch() {
    var items = [].slice.call(document.querySelectorAll('[data-clikt-fx]:not(.is-in)'));
    if (!items.length) return;

    function show(el) {
      el.classList.add('is-in');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            show(entry.target);
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
      );
      items.forEach(function (el) {
        io.observe(el);
      });
    }

    function sweep() {
      var limit = window.innerHeight * 0.92;
      var waiting = 0;
      items.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        if (el.getBoundingClientRect().top < limit) show(el);
        else waiting++;
      });
      if (!waiting) {
        window.removeEventListener('scroll', sweep);
        window.removeEventListener('resize', sweep);
      }
    }

    /*
      The first sweep waits two frames. Anything already on screen is
      tagged hidden and then revealed in the same paint otherwise, and the
      browser collapses that into no animation at all: the section simply
      appears. Below the fold it looked fine because the reveal came later
      on scroll, which is why this only showed up on a section near the top
      of a page.
    */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(sweep);
    });

    /* requestAnimationFrame does not run in a background tab, so a page
       opened in a new tab would never get its first sweep. */
    window.setTimeout(sweep, 250);

    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
  }

  /* ----------------------------------------------------------- parallax */

  function parallax() {
    /* Full-bleed backgrounds only. A framed photograph is already in the
       reveal list, and two systems writing transforms to the same element
       fight each other. */
    var els = [].slice.call(document.querySelectorAll('.clikt-cdisp__bg, .clikt-landing__hero-img'));
    if (!els.length) return;

    els.forEach(function (el) {
      el.setAttribute('data-clikt-parallax', '');
    });

    var ticking = false;

    function frame() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var box = el.getBoundingClientRect();
        if (box.bottom < -200 || box.top > vh + 200) return;
        var progress = (box.top + box.height / 2 - vh / 2) / vh;
        el.style.setProperty('--clikt-shift', (progress * 38).toFixed(1) + 'px');
      });
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }

    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* --------------------------------------------------------------- hero */

  function hero() {
    var heroes = document.querySelectorAll('.clikt-hero');

    for (var i = 0; i < heroes.length; i++) {
      (function (section) {
        var img = section.querySelector('.clikt-hero__bg');
        var release = function () {
          section.classList.add('is-ready');
        };

        if (img && !img.complete) {
          img.addEventListener('load', release, { once: true });
          img.addEventListener('error', release, { once: true });
        } else {
          window.requestAnimationFrame(release);
        }

        /* Unconditional backstop: requestAnimationFrame does not run in a
           background tab, so a page opened in a new tab would otherwise sit
           with its hero copy invisible until the visitor switched to it. */
        window.setTimeout(release, 1200);
      })(heroes[i]);
    }
  }

  function start() {
    collect();
    watch();
    parallax();
    hero();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
